import { useEffect, useState } from 'react';
import QRCode from 'qrcode.react';

import { Form, Button, Col, } from 'react-bootstrap';
import { Container, Grid, Paper, Typography, } from '@material-ui/core';

import NavBar from '../../components/NavBar/NavBar';
import UserForm from '../../components/UserForm/index';
import UsersTable from './UsersTable';

import { listUsers, createUser, regenerateUserQrCode, deleteUser, } from '../../services/api';

import useModal from '../../hooks/useModal';
import ConfirmDialog from '../../components/ConfirmDialog';


function UsersManagement() {
  const [users, setUsers] = useState([]);
  const [qrCode, setQRCode] = useState('');
  const [emailQr, setEmailQr] = useState('');

  const [userToDelete, setUserToDelete] = useState(undefined);
  const deleteUserModal = useModal((userId) => setUserToDelete(userId),
    () => setUserToDelete(undefined));


  useEffect(() => {
    getUsers();
  }, []);

  function getUsers() {
    listUsers()
      .then(({ data: result, }) => {
        setUsers(result);
      });
  }

  function getQrCode() {
    if (!emailQr) {
      alert('Selecione um usuário');
      return;
    }

    regenerateUserQrCode(emailQr)
      .then(({data}) => {
        setQRCode(data);
        getUsers();
      })
      .catch(() => {
        alert('Não foi possivel gerar o qrcode');
      });
  }

  function onCreateUser({ name, email, avatar, password, }) {
    createUser(name, email, password, avatar, true)
      .then(() => {
        getUsers();
        alert('Usuário criado');
      })
      .catch(() => {
        alert('Erro ao criar usuário');
      });
  }

  async function onDeleteUser(userId) {
    try {
      await deleteUser(userId);
      getUsers();
    } catch (error) {
      alert('Erro ao excluir usuário');
    }
  }


  return (
    <NavBar>
      <Grid
        container
        spacing={2}
        style={{
          marginBottom: '0.5rem',
          marginTop: '1rem',
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
        >
          <Container
            component={Paper}
            style={{
              padding: '1rem',
            }}
          >
            <Typography
              variant="h6"
              paragraph
            >
              Registro de usuários
            </Typography>

            <UserForm onSubmit={onCreateUser} />
          </Container>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
        >
          <Container component={Paper} >
            <Typography
              variant="h6"
              paragraph
            >
              Usuários cadastrados no sistema
            </Typography>

            <UsersTable
              users={users}
              onDelete={deleteUserModal.onOpen}
            />
          </Container>
        </Grid>
      </Grid>

      <Container
        component={Paper}
        maxWidth="xl"
        style={{
          paddingBottom: '1rem',
        }}
      >
        <Typography>
          Escolha um usuário para gerar o QR Code
        </Typography>

        <Grid
          container
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Grid
            item
            xs={true}
          >
            <Form.Row>
              <Form.Group
                as={Col}
                controlId="formGridState"
              >
                <Form.Control
                  as="select"
                  onChange={(e) => setEmailQr(e.target.value)}
                >
                  <option value="" ></option>
                  {
                    users.map((user) => {
                      return (
                        <option
                          key={user._id}
                          value={user.email}
                        >
                          { user.email }
                        </option>
                      );
                    })
                  }
                </Form.Control>
              </Form.Group>
            </Form.Row>
          </Grid>

          <Button
            onClick={getQrCode}
            style={{
              marginLeft: '1rem',
            }}
          >
            Solicitar QRCODE{' '}
          </Button>
        </Grid>

        {
          qrCode ?
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <QRCode value={qrCode} />
          </div> :
          null
        }
      </Container>

      <ConfirmDialog
        open={deleteUserModal.value}
        onClose={deleteUserModal.onClose}
        onConfirm={() => {
          onDeleteUser(userToDelete);
          deleteUserModal.onClose();
        }}
        text="Tem certeza que deseja excluir o usuário?"
        secondaryText="O usuário será excluído permanentemente"
        confirmationButtonLabel="Excluir"
        buttonBackgroundColor="red"
      />
    </NavBar>
  )
}

export default UsersManagement;
